import React from "react";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location";
import { ajax } from "tsi-common-react/src/utils/ajax";

import { EmailSendStorePostData } from "../models";
import { buildStoreData } from "../utils";
import { LocatorSendSingleStoreModal } from "./LocatorSendSingleStore_Modal";
import { LocatorSurveyModal } from "./LocatorSurveyModal";

interface IProps {
    store: IRetailStoreWithDistance;
}

const submitStoreEmail = async (
    store: IRetailStoreWithDistance,
    recipient: string,
): Promise<void> => {
    const stores = [store];
    const selected = new Set([store.external_id]);
    const data: EmailSendStorePostData = {
        email: recipient,
        stores: buildStoreData(stores, selected),
    };
    await ajax
        .post("https://api.promosis.com/api/v1/tsi-2249/email")
        .send(data);
};

export const LocatorSendSingleStore = (props: IProps): React.ReactNode => {
    const [surveyOpen, setSurveyOpen] = React.useState(false);
    const [surveyEmail, setSurveyEmail] = React.useState("");

    const handleSubmit = async (recipient: string): Promise<void> => {
        await submitStoreEmail(props.store, recipient);
        setSurveyOpen(true);
        setSurveyEmail(recipient);
    };

    const handleSurveyClose = (): void => {
        setSurveyOpen(false);
    };

    return (
        <>
            <LocatorSendSingleStoreModal onSubmit={handleSubmit} />
            <LocatorSurveyModal
                isOpen={surveyOpen}
                email={surveyEmail}
                onClose={handleSurveyClose}
            />
        </>
    );
};
